import { Marker } from "react-leaflet";
import { DefaultIcon } from "./Icons";

export default function UserMarker({ position }) {
  return (
    <Marker
      position={position}
      icon={DefaultIcon}
      eventHandlers={{
        click: () => {},
      }}
    ></Marker>
  );
}
